import { defineMessages, FormattedMessage, useIntl } from 'react-intl';

import { Image, Link, LinkVariant, PureButton, SearchIcon } from '@jsmdg/yoshi';
import styles from './VenuesMapPreview.module.scss';

const messages = defineMessages({
    mapImageAltText: {
        defaultMessage: 'Veranstaltungsorte in Kartenansicht',
    },
});

type VenuesMapPreviewProps = {
    readonly mapImageUrl: string;
    readonly onMapClicked: () => void;
};

const VenuesMapPreview = ({ mapImageUrl, onMapClicked }: VenuesMapPreviewProps): JSX.Element => {
    const intl = useIntl();

    return (
        <PureButton
            className="theme-text-body-text theme-text-link w-100"
            data-testid="mapWrapper"
            onClick={() => onMapClicked()}
        >
            <div className={styles.mapWrapper}>
                <Image
                    className="d-block w-100"
                    src={mapImageUrl}
                    alt={intl.formatMessage(messages.mapImageAltText)}
                    lazyLoad
                />
                <Link
                    className={styles.osmTerms}
                    href="https://www.openstreetmap.org/copyright"
                    target="_blank"
                    title="OpenStreetMaps Copyright"
                    variant={LinkVariant.Grey}
                >
                    © OpenStreetMaps
                </Link>
            </div>
            <div className={styles.zoomMap}>
                <SearchIcon size={20} /> <FormattedMessage defaultMessage="Karte in Großansicht" />
            </div>
        </PureButton>
    );
};

export { VenuesMapPreview };
